import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-four',
  templateUrl: './demo-four.component.html',
  styleUrls: ['./demo-four.component.scss']
})
export class DemoFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
